// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Grid, LinearProgress, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';

// assets
import UserAvatar from 'ui-component/extended/UserAvatar';
import React, { FC } from 'react';
import Notification from 'models/results/notification';
import { useTranslation } from 'react-i18next';
import { calculateMinutes } from 'utils/date';
import NotificationStatus from './NotificationStatus';

// styles
const ListItemWrapper = styled('div')(({ theme }) => ({
    cursor: 'pointer',
    padding: 8,
    borderRadius: 8,
    '&:hover': {
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));

const TextWrapper = styled('div')(() => ({
    gap: 4
}));

// ==============================|| NOTIFICATION LIST ITEM ||============================== //

interface Props {
    notifications: Notification[];
}

const NotificationList: FC<Props> = (props) => {
    const { notifications } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <List
            sx={{
                width: '100%',
                maxWidth: 330,
                minWidth: 300,
                py: 0,
                borderRadius: '10px',
                [theme.breakpoints.down('md')]: {
                    maxWidth: 300
                },
                '& .MuiListItemSecondaryAction-root': {
                    top: 22
                },
                '& .MuiDivider-root': {
                    my: 0
                },
                '& .list-container': {
                    pl: 7
                }
            }}
        >
            {notifications.map((notification) => (
                <React.Fragment key={notification.id}>
                    <ListItemWrapper>
                        <ListItem alignItems="center">
                            <ListItemAvatar>
                                <UserAvatar
                                    src={notification.user.avatar}
                                >{`${notification.user.name} ${notification.user.surname}`}</UserAvatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <TextWrapper>
                                        <Typography variant="h5" display="block" noWrap>
                                            {`${notification.user.name} ${notification.user.surname}`}
                                        </Typography>
                                        <Typography variant="caption" display="block">
                                            {notification.description}
                                        </Typography>
                                    </TextWrapper>
                                }
                            />
                        </ListItem>
                        <Grid container spacing={1} direction="column" className="list-container">
                            <Grid item xs={12} container direction="row" alignItems="center">
                                {notification.dateOfInsert && (
                                    <Grid item xs zeroMinWidth>
                                        <Typography variant="caption" display="block" gutterBottom>
                                            {calculateMinutes(notification.dateOfInsert)}
                                        </Typography>
                                    </Grid>
                                )}

                                <Grid item>
                                    <NotificationStatus status={notification.notificationStatus} />
                                </Grid>
                            </Grid>
                            {notification.notificationStatus === 0 && (
                                <Grid item xs={12}>
                                    <LinearProgress />
                                </Grid>
                            )}
                        </Grid>
                    </ListItemWrapper>
                </React.Fragment>
            ))}
        </List>
    );
};

export default NotificationList;
